export const HR_ALL_MODE = "HR_ALL";
export const HR_HEALTHCARE_MODE = "HR_HEALTHCARE";
